//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as pintuanApi from '@/api/pintuanApi';
import throttle from '@/utils/throttle';
export default {
  data: function data() {
    return {
      visible: false,
      pram: {},
      initloading: false,
      spuLists: [{
        id: 1
      }, {
        id: 2
      }, {
        id: 3
      }]
    };
  },
  mounted: function mounted() {},
  methods: {
    throttle: throttle,
    openInit: function openInit() {
      this.getSupLists();
      this.pram = {};
      this.visible = true;
    },
    getSupLists: function getSupLists(spuName) {
      var _this = this;
      this.spuLists = [];
      this.initloading = true;
      pintuanApi.getSpuListss(spuName).then(function (res) {
        _this.spuLists = (res === null || res === void 0 ? void 0 : res.list) || [];
        _this.initloading = false;
      }).catch(function (err) {
        _this.initloading = false;
      });
    },
    handleSpuSearch: function handleSpuSearch(data) {
      var _this2 = this;
      this.throttle(function () {
        _this2.getSupLists(data);
      }, 300)();
    },
    handerSubmit: function handerSubmit() {
      var _this$pram,
        _this$pram2,
        _this3 = this;
      if (!((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.spuId)) {
        this.$message.warning('请选择商品！');
        return;
      }
      ;
      pintuanApi.initPinGoods((_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? void 0 : _this$pram2.spuId).then(function (res) {
        var _this3$pram;
        _this3.$router.push({
          path: "/store/list/creatPintuan/0/0/".concat((_this3$pram = _this3.pram) === null || _this3$pram === void 0 ? void 0 : _this3$pram.spuId)
        });
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};